import { render, staticRenderFns } from "./workShopEntry.vue?vue&type=template&id=c37b4dfc&scoped=true"
import script from "./workShopEntry.vue?vue&type=script&lang=js"
export * from "./workShopEntry.vue?vue&type=script&lang=js"
import style0 from "./workShopEntry.vue?vue&type=style&index=0&id=c37b4dfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c37b4dfc",
  null
  
)

export default component.exports